import { render, staticRenderFns } from "./staff-search.vue?vue&type=template&id=73966862&scoped=true&"
import script from "./staff-search.vue?vue&type=script&lang=js&"
export * from "./staff-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73966862",
  null
  
)

export default component.exports